import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import ErrorBoundary from './components/ErrorBoundary';
import './i18n';

ReactDOM.render(
	<Router>
		<React.StrictMode>
			<ErrorBoundary>
				<ThemeContextProvider>
					<App />
				</ThemeContextProvider>
			</ErrorBoundary>
		</React.StrictMode>
	</Router>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
